import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowCenter"><Path d="M20.5 13.5V3.5L3.5 3.5L3.5 20.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 15.5V9.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10 10L18 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowCenter;
